import type { CouponData, OfferData } from '@wwe-portal/entities/offer.type';
import { OfferCardTypeEnum } from '@wwe-portal/entities/offer.type';

export const validOfferCardTypes = Object.values(OfferCardTypeEnum);
export const isValidOfferCardType = (
  type: unknown
): type is OfferCardTypeEnum => {
  return validOfferCardTypes.includes(type as never);
};

export const tryGetOfferCardType = (offerData: OfferData) => {
  if (isValidOfferCardType(offerData.CombinationType)) {
    return offerData.CombinationType;
  }
  return OfferCardTypeEnum.SINGLE1;
};
export const offerToCouponProps = (offerData: Partial<CouponData>) => {
  return {
    bonusItems: offerData,
    itemImg: offerData.OfferItemImage,
    itemNames: offerData.OfferItemContent,
    backgroundImg: offerData.OfferBackgroundImage,
    name: offerData.StoreItemName,
    quantity: offerData.quantity,
    price: offerData?.Price?.USD,
    id: offerData.OffersID,
    cashPackQuantity:
      offerData?.offerId?.includes('Pack') && offerData.OfferItemTexts?.[0]
        ? +offerData.OfferItemTexts[0].replace('x', '')
        : null,
  };
};
